import { banner as actions } from '../actions'
import * as R from 'ramda'

export const reducer = {}

reducer[actions.SET_BANNER] = ({ state, action }) => {
  return R.mergeRight(state.banner, action.data)
}
